import React from 'react';
import Navbar from "./components/Navbar"
import Home from './components/Home';
import SocialLinks from './components/SocialLinks';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Experience from './components/Experience';
import Contact from './components/Contact';
import SocialLinksPC from './components/SocialLinksPC';

function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <About />
      <Portfolio />
      <Experience />
      <Contact />
      <SocialLinksPC />

      <SocialLinks />
    </div>
  );
}

export default App;
